import { isURL, isEmpty } from 'validator';

function validate(fieldName) {
  return (value = '') => {
    if (typeof value === 'object' && value !== null) {
      value = value.label; // eslint-disable-line no-param-reassign
    }

    return isEmpty(value || '') ||
      isURL(value || '', { require_protocol: false })
      ? undefined
      : `${fieldName} is not a valid URL`;
  };
}

export function url(fieldName) {
  return value => {
    if (Array.isArray(value)) {
      return value.every(validate(fieldName));
    }
    return validate(fieldName)(value);
  };
}
